import React from 'react';
import debounce from 'lodash/debounce';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import s from './NumericField.scss';
var NumericField = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, _b = _a.minValue, minValue = _b === void 0 ? 0 : _b, _c = _a.maxValue, maxValue = _c === void 0 ? 100 : _c, _d = _a.sliderStep, sliderStep = _d === void 0 ? 1 : _d;
    return (React.createElement("div", { className: s['root'] },
        React.createElement("label", { className: s['label'] }, label),
        React.createElement("input", { className: s['range-slider'], value: value, type: "range", step: sliderStep, max: maxValue, min: minValue, onChange: debounce(function (ev) { return onChange(ev.target.value); }, 150, {
                leading: true,
            }) }),
        React.createElement("div", { className: s['range-input-wrapper'] },
            React.createElement(TextInput, { id: "editor-gallery-range-input", className: s['range-input'], type: 'number', value: value.toString(), onChange: function (ev) { return onChange(ev.target.value); }, min: minValue, max: maxValue, label: label, isLabelHidden: true }))));
};
export default NumericField;
//# sourceMappingURL=NumericField.js.map